import { render } from "./areaEvaPeopleNumEchart.vue?vue&type=template&id=7bdbaf16&scoped=true"
import script from "./areaEvaPeopleNumEchart.vue?vue&type=script&lang=js"
export * from "./areaEvaPeopleNumEchart.vue?vue&type=script&lang=js"

import "./areaEvaPeopleNumEchart.vue?vue&type=style&index=0&id=7bdbaf16&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bdbaf16"]])

export default __exports__